export const PLAN03 = require('./PLAN03.webp');

const ELEMENTS = {
  PLAN03: 'PLAN03'
} as const;
export default ELEMENTS;
